import React, { useState, useEffect } from 'react';

const SAFE_URL_REGEX = /^(https?:\/\/|mailto:|\/)/i;

export const LinkModal = ({ isOpen, onClose, onSave, onRemove, initialUrl = '' }) => {
  const [url, setUrl] = useState(initialUrl);

  useEffect(() => {
    setUrl(initialUrl);
  }, [initialUrl, isOpen]);

  if (!isOpen) return null;

  const handleSave = () => {
    const trimmed = url.trim();
    if (trimmed && !SAFE_URL_REGEX.test(trimmed)) {
      alert('Please enter a valid URL (starting with http://, https://, or mailto:)');
      return;
    }
    onSave(trimmed);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>{initialUrl ? 'Edit Link' : 'Add Link'}</h3>
        <input
          type="url"
          placeholder="https://example.com"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          autoFocus
        />
        <div className="modal-actions">
          {initialUrl && (
            <button
              className="toolbar-btn"
              style={{ color: '#dc2626', marginRight: 'auto' }}
              onClick={() => { onRemove(); onClose(); }}
            >
              Remove
            </button>
          )}
          <button className="toolbar-btn" onClick={onClose}>Cancel</button>
          <button className="toolbar-btn is-active" onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
};